import { render, staticRenderFns } from "./Direct_Purchase__CSV_Import.vue?vue&type=template&id=09071924&scoped=true&"
import script from "./Direct_Purchase__CSV_Import.vue?vue&type=script&lang=js&"
export * from "./Direct_Purchase__CSV_Import.vue?vue&type=script&lang=js&"
import style0 from "./Direct_Purchase__CSV_Import.vue?vue&type=style&index=0&id=09071924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09071924",
  null
  
)

export default component.exports